import { inject, observer } from "mobx-react";
import React from "react";
import { useTranslation } from "react-i18next";
import { Button, DivPaper, Heading, Spacer, Text } from "src/components";
import { theme } from "src/config";
import { AuthStore, RoutingStore } from "src/stores";
import styled from "styled-components";
import { getRoutePath, LocationState, Page } from '../routes';

export interface IWorkspacesProps{
  authStore?:    AuthStore;
  routingStore?: RoutingStore;
}


export const Workspaces = inject("authStore", "routingStore")(observer((props: IWorkspacesProps): JSX.Element => {
  
  const { authStore, routingStore} = props;
  const { t, i18n } = useTranslation();

  const setWorkspace = () => {
    localStorage.setItem('workspace_id', '1');
    routingStore.push(getRoutePath(Page.Dashboard));
  }

  return (
    <StyledDivPaper style={theme.paper.regular} justifyContent = "center" $center $noShadow>
      <Heading type="h3" style={{marginBottom: "1rem"}}>{t("select_workspace")}!</Heading>
      <Text size="large" weight="bold" style={{marginBottom: "0.5rem"}}>{t("workspaces")}:</Text>
      <Button onClick={setWorkspace}>Set workspace</Button>
    </StyledDivPaper>
  );
}));

const StyledDivPaper = styled(DivPaper)`
  margin-top: 25vh;
  width:      40rem;
`

const ButtonContainer = styled.div`
  display:         flex;
  flex-direction:  row;
  justify-content: space-between;
`